export const environment = {
  production: false,
  baseUrl: 'https://localhost:3000',
  api: '/api/v1',
  allWorkspaceId : '058d03e3-9abd-409f-8ad2-4cfba8d189a2',
  shortTitle: 'تارت',
  longTitle: 'هوش کسب و کار تارت',
  socketBaseUrl: 'https://stage.tart.tech:5000/signalRHub'
};
